import React from 'react';
import styled from 'App/styled';
import Star from '../StarIcons/StarSvg';
import { hexToRgb } from '@nykaa/ui-components/styles/utils';

interface ProgressBarProp {
  count: string;
  per: number;
  id: number;
}
const Wrapper = styled.div`
  ${({ theme }) => theme.typography.bodyMedium};
  line-height: unset;
  display: -webkit-box;
  padding-left: ${({ theme }) => theme.spacing.spacing120};
`;
const RateId = styled.label`
  display: flex;
  svg {
    margin-top: ${({ theme }) => theme.spacing.spacing10};
  }
`;
const Bar = styled.progress`
  ${({ theme }) => theme.borders.border100};
  border-radius: ${({ theme }) => theme.borders.radius10};
  border-color: ${({ theme }) => theme.colors.white};
  width: 120px;
  height: 11px;
  &::-webkit-progress-bar {
    background-color: ${({ theme }) => hexToRgb(theme.colors.state, 0.22)};
    border-radius: ${({ theme }) => theme.borders.radius10};
  }
  &::-webkit-progress-value {
    background-color: ${({ theme }) => hexToRgb(theme.colors.textPrimary, 0.7)};
  }
`;
const Count = styled.span`
  text-align: left;
  padding-right: ${({ theme }) => theme.spacing.spacing20};
  padding-left: ${({ theme }) => theme.spacing.spacing40};
  color: ${({ theme }) => theme.colors.textSecondary};
`;
const ProgressBar = ({ count, per, id }: ProgressBarProp) => (
  <Wrapper aria-label={`Rating: ${id} Reviews: (${count})`}>
    <RateId aria-hidden="true">
      {id}
      <Star />
    </RateId>
    <Bar
      value={Math.floor(per)}
      max={100}
      aria-hidden="true"
    >
      {per}
    </Bar>
    <Count aria-hidden="true">{count}</Count>
  </Wrapper>
);

export default ProgressBar;
